<template>
  <model-table
    :collection="transferPayouts"
    :columns="columns"
    :show-add="false"
    :show-edit="false"
    :descending="true"
    :filter-by-data-array="filteredPayouts"
  />
</template>
<script>

import { INDY_PAYOUT_TYPES } from 'src/models/transfer/TransferPayout'
import ModelTable from 'src/modules/admin/components/ModelTable'

export default {
  name: 'TransferPayoutTable',
  components: {
    ModelTable
  },
  props: {
    transferPayouts: {
      type: Object,
      required: true
    },
    showIndyPayouts: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    filteredPayouts () {
      if (this.showIndyPayouts) {
        return this.transferPayouts.data
      } else {
        return _.filter(this.transferPayouts.data, transferPayout => !_.includes(INDY_PAYOUT_TYPES, transferPayout.type))
      }
    },
    columns () {
      if (this.showIndyPayouts) {
        return [
          { field: 'id' },
          { field: (row) => _.startCase(row.type), name: 'type', component: 'chip' },
          { field: (row) => _.startCase(row.status), name: 'status' },
          { field: 'arrivalDate', component: 'full-date' },
          { field: 'payoutId' },
          { field: 'statementDescriptor' },
          { field: 'amount', component: 'money' }
        ]
      } else {
        return [
          { field: 'id' },
          { field: (row) => _.startCase(row.status), name: 'status' },
          { field: 'arrivalDate', component: 'full-date' },
          { field: 'payoutId' },
          { field: 'statementDescriptor' },
          { field: 'amount', component: 'money' }
        ]
      }
    }
  }
}
</script>
